/* nutrient-ops theme-bundle: ns-wishlist v11 — installed by the LP Builder from nutrient-ops (website/ns-wishlist/theme). Edit the repo copy and reinstall; hand edits here are overwritten on the next install. */
/*
 * Storefront wishlist (nutrient-ops website/ns-wishlist).
 *
 * Loaded by snippets/ns-wishlist-boot.liquid only while the wishlist is switched on, so with the
 * switch off none of this runs and nothing is read, written or cleared.
 *
 *   - Hearts: added to every Booster product card on the page (and any added later — filters,
 *     the add-to-cart popup) and beside Add to cart on product pages. Cards are left untouched
 *     in the theme; the heart is an overlay button placed next to the card's image link.
 *   - Logged in: the list lives in the account (App Proxy /apps/wishlist → storefront-wishlist
 *     worker). The theme prints the account's copy into #ns-wl-config so hearts are filled
 *     on first paint.
 *   - Guest: the list lives in this browser (localStorage). On the next signed-in visit it is
 *     merged into the account and cleared here.
 *   - /pages/wishlist: [data-ns-wl-page] is drawn from /products/<handle>.js.
 *   - Analytics: wishlist_* events to dataLayer + Shopify.analytics.publish (the GA4 custom pixel
 *     forwards them), and "Added to Wishlist" to Klaviyo for browsers Klaviyo already knows.
 */
(function () {
  "use strict";
  // Booster declares BoosterTheme as a top-level const, so it is never a property of window.
  function booster() { return typeof BoosterTheme !== "undefined" ? BoosterTheme : null; }
  var cfgEl = document.getElementById("ns-wl-config");
  if (!cfgEl || window.__nsWishlist) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  window.__nsWishlist = true;

  var LS_KEY = "ns_wishlist_v1";
  var NUDGE_KEY = "ns_wishlist_nudged";
  var SYNC_KEY = "ns_wishlist_synced";
  var MAX = 100;
  var HEART = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.3-9.2C1.4 7.9 3.4 4.4 7 4.4c2 0 3.5 1.1 5 2.9 1.5-1.8 3-2.9 5-2.9 3.6 0 5.6 3.5 4.3 7C19.6 16 12 20.6 12 20.6Z"/></svg>';

  // ── storage ─────────────────────────────────────────────────────────────
  function lsGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, v) { try { window.localStorage.setItem(key, v); } catch (e) { /* private mode */ } }
  function lsDel(key) { try { window.localStorage.removeItem(key); } catch (e) { /* private mode */ } }
  function ssGet(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, v) { try { window.sessionStorage.setItem(key, v); } catch (e) { /* private mode */ } }

  function readGuest() {
    try {
      var list = JSON.parse(lsGet(LS_KEY) || "[]");
      return Array.isArray(list) ? list.filter(function (x) { return x && x.handle; }) : [];
    } catch (e) { return []; }
  }
  function writeGuest() { lsSet(LS_KEY, JSON.stringify(items.map(function (x) { return { id: x.id || null, handle: x.handle }; }))); }

  // items: newest first, [{ id: "123" | null, handle: "freeze-dried-corn" }]
  var items = cfg.loggedIn ? (cfg.items || []).map(norm) : readGuest().map(norm);
  function norm(x) { return { id: x.id ? String(x.id) : null, handle: String(x.handle || "") }; }
  function find(id, handle) {
    for (var i = 0; i < items.length; i++) {
      if ((id && items[i].id === String(id)) || (handle && items[i].handle === handle)) return i;
    }
    return -1;
  }
  function has(id, handle) { return find(id, handle) !== -1; }

  // ── server (logged in) ──────────────────────────────────────────────────
  function api(method, body) {
    return fetch(cfg.proxy, {
      method: method,
      credentials: "same-origin",
      headers: body ? { "Content-Type": "application/json", Accept: "application/json" } : { Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (j && j.mode === "off") { shutDown(); throw new Error("off"); }
        if (!r.ok) throw new Error(j.error || "HTTP " + r.status);
        return j;
      });
    });
  }
  function adoptServer(j) {
    if (!j || !Array.isArray(j.items)) return;
    items = j.items.map(norm);
    refresh();
  }

  // The switch went off while this page was open: hide everything, keep every list.
  function shutDown() {
    document.querySelectorAll(".ns-wl-heart, .ns-wl-header, .ns-wl-menu-link").forEach(function (el) { el.remove(); });
    if (observer) observer.disconnect();
  }

  // ── analytics ───────────────────────────────────────────────────────────
  function emit(event, payload) {
    var data = Object.assign({ wl_logged_in: !!cfg.loggedIn, wl_count: items.length }, payload || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data)); } catch (e) { /* noop */ }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(event, data); } catch (e) { /* noop */ }
  }
  function klaviyoAdd(item, title) {
    // Only reaches Klaviyo for a browser it already recognises (signed in, or arrived from an email).
    try {
      var k = window.klaviyo || (window._learnq = window._learnq || []);
      k.push(["track", "Added to Wishlist", {
        ProductID: item.id, Handle: item.handle, ProductName: title || item.handle,
        URL: location.origin + "/products/" + item.handle, WishlistCount: items.length,
      }]);
    } catch (e) { /* noop */ }
  }

  // ── announcements + toast ───────────────────────────────────────────────
  var live = document.createElement("div");
  live.className = "ns-wl-sr"; live.setAttribute("aria-live", "polite"); live.setAttribute("role", "status");
  document.body.appendChild(live);
  function say(text) { live.textContent = ""; setTimeout(function () { live.textContent = text; }, 30); }

  var toastEl = null, toastTimer = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "ns-wl-toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add("is-open");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-open"); }, 6000);
  }
  function loginHref() {
    var sep = cfg.loginUrl.indexOf("?") === -1 ? "?" : "&";
    return cfg.loginUrl + sep + "return_url=" + encodeURIComponent(location.pathname + location.search);
  }

  // ── toggle ──────────────────────────────────────────────────────────────
  function resolveId(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("product " + r.status); return r.json(); })
      .then(function (p) { return String(p.id); });
  }

  function toggle(id, handle, title, source) {
    var on = has(id, handle);
    if (!on && items.length >= MAX) { toast("Your wishlist is full (" + MAX + " products). Remove one to add another."); return; }
    var before = items.slice();
    if (on) items.splice(find(id, handle), 1);
    else items.unshift({ id: id ? String(id) : null, handle: handle });
    refresh();
    say(on ? (title || "Product") + " removed from your wishlist" : (title || "Product") + " saved to your wishlist");
    var item = { id: id ? String(id) : null, handle: handle };
    emit(on ? "wishlist_remove" : "wishlist_add", { wl_product_id: item.id || "", wl_handle: handle, wl_source: source });
    if (!on) klaviyoAdd(item, title);
    if (on && pageEl) {
      toast(esc(title || "Product") + ' removed. <button type="button" class="ns-wl-toast__btn" data-ns-wl-undo>Undo</button>');
      var undo = toastEl.querySelector("[data-ns-wl-undo]");
      undo.addEventListener("click", function () { toastEl.classList.remove("is-open"); toggle(id, handle, title, "page"); });
    } else if (!on && cfg.loggedIn && !lsGet(NUDGE_KEY)) {
      lsSet(NUDGE_KEY, "1");
      toast('Saved to your wishlist. <a href="' + cfg.pageUrl + '">View wishlist</a>');
    }

    if (!cfg.loggedIn) {
      writeGuest();
      if (!on && !lsGet(NUDGE_KEY)) {
        lsSet(NUDGE_KEY, "1");
        toast('Saved on this device. <a href="' + loginHref() + '">Sign in</a> to keep your wishlist everywhere.');
      }
      return;
    }
    (id ? Promise.resolve(String(id)) : resolveId(handle))
      .then(function (pid) { return api("POST", { action: on ? "remove" : "add", product_id: pid, handle: handle, source: source }); })
      .then(adoptServer)
      .catch(function (e) {
        if (e && e.message === "off") return;
        items = before; refresh();
        toast("Sorry, we couldn't update your wishlist. Please try again.");
      });
  }

  // ── hearts ──────────────────────────────────────────────────────────────
  function handleFromHref(href) {
    var m = /\/products\/([a-z0-9][a-z0-9-]*)/i.exec(href || "");
    return m ? m[1].toLowerCase() : null;
  }
  function paint(btn) {
    var on = has(btn.dataset.id, btn.dataset.handle);
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    var name = btn.dataset.title || "this product";
    btn.setAttribute("aria-label", on ? "Remove " + name + " from wishlist" : "Save " + name + " to wishlist");
    btn.title = on ? "Saved to wishlist" : "Save to wishlist";
  }
  function makeHeart(cls, id, handle, title, source) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = cls;
    if (id) b.dataset.id = String(id);
    b.dataset.handle = handle;
    if (title) b.dataset.title = title;
    b.dataset.source = source;
    b.innerHTML = HEART;
    b.addEventListener("click", function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      toggle(b.dataset.id || null, b.dataset.handle, b.dataset.title, b.dataset.source);
    });
    paint(b);
    return b;
  }

  // Our card titles carry an inline <style>; read the text without it.
  function cardTitle(el) {
    if (!el) return "";
    var c = el.cloneNode(true);
    c.querySelectorAll("style, script").forEach(function (x) { x.remove(); });
    return c.textContent.trim().replace(/\s+/g, " ");
  }

  function decorateCards(root) {
    var cards = (root || document).querySelectorAll(".card--default:not([data-ns-wl])");
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.setAttribute("data-ns-wl", "1");
      var img = card.querySelector(".card__img--container");
      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleFromHref(link && link.getAttribute("href"));
      if (!img || !handle) continue;
      var idEl = card.querySelector("[data-product-card-swatch-id]");
      var id = idEl ? idEl.getAttribute("data-product-card-swatch-id") : null;
      var title = cardTitle(card.querySelector(".ns-card-title") || card.querySelector(".card__title"));
      var source = card.closest(".upsell__container, [data-upsell-container], .api__upsell") ? "popup" : "card";
      card.classList.add("ns-wl-card");
      img.insertAdjacentElement("afterend", makeHeart("ns-wl-heart", id, handle, title, source));
    }
    // Redesign collection-v2 cards (collections, best sellers, recommendations): the same heart, top-right of the photo.
    var cv2 = (root || document).querySelectorAll(".ns-cv2-card:not([data-ns-wl])");
    for (var j = 0; j < cv2.length; j++) {
      var c2 = cv2[j];
      c2.setAttribute("data-ns-wl", "1");
      var media = c2.querySelector(".ns-cv2-card__media");
      var link2 = c2.querySelector('a[href*="/products/"]');
      var handle2 = handleFromHref(link2 && link2.getAttribute("href"));
      if (!media || !handle2) continue;
      var id2 = c2.getAttribute("data-product") || null;
      var title2 = cardTitle(c2.querySelector(".ns-cv2-card__title"));
      c2.classList.add("ns-wl-card");
      media.insertAdjacentElement("afterend", makeHeart("ns-wl-heart", id2, handle2, title2, "card"));
    }
  }

  // Product page: the same round heart as the cards, on the main photo's corner. The buy row is
  // full at desktop width (a heart there wraps "Add to cart"), so it never goes there.
  function decoratePdp() {
    if (!cfg.product || document.querySelector(".ns-wl-heart--pdp")) return;
    var media = document.querySelector(".product__row .slider--product__holder")
      || document.querySelector(".product__row .gallery");
    if (!media) return;
    media.classList.add("ns-wl-media");
    media.appendChild(makeHeart("ns-wl-heart ns-wl-heart--pdp", cfg.product.id, cfg.product.handle, cfg.product.title, "pdp"));
  }

  // Phones: a "Wishlist (n)" link at the top of the slide-out menu's footer (beside Account),
  // instead of a heart in the crowded header row.
  function decorateMobileMenu() {
    var nav = document.querySelector("nav.mobile__navigation");
    if (!nav || nav.querySelector(".ns-wl-menu-link")) return;
    var foot = nav.querySelector(".mobile__navigation__footer");
    var a = document.createElement("a");
    a.className = "user__link ns-wl-menu-link";
    a.href = cfg.pageUrl;
    a.innerHTML = '<svg class="ns-wl-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.3-9.2C1.4 7.9 3.4 4.4 7 4.4c2 0 3.5 1.1 5 2.9 1.5-1.8 3-2.9 5-2.9 3.6 0 5.6 3.5 4.3 7C19.6 16 12 20.6 12 20.6Z"/></svg>'
      + 'Wishlist<span class="ns-wl-menu-link__count" data-ns-wl-count-text></span>';
    if (foot) foot.insertBefore(a, foot.firstChild); else nav.appendChild(a);
  }

  function refresh() {
    document.querySelectorAll(".ns-wl-heart").forEach(paint);
    document.querySelectorAll("[data-ns-wl-count]").forEach(function (el) {
      el.textContent = String(items.length);
      el.hidden = items.length === 0;
    });
    document.querySelectorAll("[data-ns-wl-count-text]").forEach(function (el) {
      el.textContent = items.length ? " (" + items.length + ")" : "";
    });
    document.querySelectorAll("[data-ns-wl-header]").forEach(function (a) {
      a.setAttribute("aria-label", items.length ? "Wishlist, " + items.length + (items.length === 1 ? " product" : " products") : "Wishlist");
    });
    if (pageEl) syncPage();
  }

  var observer = null, pending = false;
  function watch() {
    if (!window.MutationObserver) return;
    observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorateCards(document); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── /pages/wishlist ─────────────────────────────────────────────────────
  // Saved products are drawn as the site's own product cards (Booster's product-card-default),
  // rendered by sections/ns-wishlist-cards on the search page — /search?q=<handles>&sections=… —
  // so price, sale tag, reviews and the Add to cart label are exactly as on collection pages.
  var pageEl = document.querySelector("[data-ns-wl-page]");
  var cardCache = {};
  function q(sel) { return pageEl ? pageEl.querySelector(sel) : null; }

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try { return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format(cents / 100); } catch (e) { return "$" + (cents / 100).toFixed(2); }
  }
  // Card images arrive as Booster lazy images (data-srcset + a placeholder src). Booster converts
  // them once at start-up, and this script usually runs before Booster exists, so load the images
  // of cards we insert ourselves: hand them to the browser's native lazy loading, as Booster would.
  function loadImages(root) {
    root.querySelectorAll("img[data-srcset], img[data-src]").forEach(function (img) {
      if (img.dataset.bstrInitd) return;
      if (img.dataset.sizes && img.dataset.sizes !== "auto") img.sizes = img.dataset.sizes;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.loading = "lazy";
      img.dataset.bstrInitd = "true";
      img.classList.remove("lazyload");
      img.classList.add("lazyloaded");
    });
    try { var B = booster(); if (B && B.lazy && B.lazy.update) B.lazy.update(); } catch (e) { /* noop */ }
  }
  function fragment(html) { var t = document.createElement("template"); t.innerHTML = html; return t.content; }

  // handle → card element HTML (null = not available). Fetches only handles not seen yet, 20 per
  // request (the section's all_products limit). No Accept: application/json header: with it
  // Shopify answers with JSON data and ignores ?sections=.
  var CARD_BATCH = 20;
  function loadCards(handles) {
    var missing = handles.filter(function (h) { return !(h in cardCache); });
    var batches = [];
    for (var i = 0; i < missing.length; i += CARD_BATCH) batches.push(missing.slice(i, i + CARD_BATCH));
    return Promise.all(batches.map(function (batch) {
      return fetch("/search?type=product&sections=ns-wishlist-cards&q=" + encodeURIComponent(batch.join(" ")))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var found = {};
          if (j && j["ns-wishlist-cards"]) {
            fragment(j["ns-wishlist-cards"]).querySelectorAll("[data-ns-wl-card]").forEach(function (el) { found[el.dataset.handle] = el.outerHTML; });
          }
          batch.forEach(function (h) { cardCache[h] = found[h] || null; });
        })
        .catch(function () { /* leave uncached: retried on the next render */ });
    })).then(function () { return handles.map(function (h) { return cardCache[h] || null; }); });
  }

  var pageRendered = null;
  function syncPage() {
    var key = items.map(function (x) { return x.handle; }).join(",");
    if (key === pageRendered) return;
    pageRendered = key;
    renderPage(key);
  }

  function renderPage(key) {
    var grid = q("[data-ns-wl-grid]");
    if (!grid) return;
    if (!items.length) { showPage([]); return; }
    var snapshot = items.slice();
    loadCards(snapshot.map(function (x) { return x.handle; })).then(function (htmls) {
      if (key !== pageRendered) return; // the list changed while loading
      var cards = [];
      htmls.forEach(function (html, i) {
        var el = html && fragment(html).querySelector("[data-ns-wl-card]");
        if (!el) return; // deleted or unpublished: stays saved, not shown
        if (!snapshot[i].id && el.dataset.id) snapshot[i].id = el.dataset.id;
        cards.push(el);
      });
      grid.textContent = "";
      cards.forEach(function (el) { grid.appendChild(el); });
      decorateCards(grid);
      loadImages(grid);
      showPage(cards);
    });
  }

  function showPage(cards) {
    var loading = q("[data-ns-wl-loading]"); if (loading) loading.hidden = true;
    var empty = q("[data-ns-wl-empty]"); if (empty) empty.hidden = cards.length > 0;
    var grid = q("[data-ns-wl-grid]"); if (grid) grid.hidden = cards.length === 0;
    var summary = document.querySelector("[data-ns-wl-summary]");
    var actions = document.querySelector("[data-ns-wl-actions]");
    var direct = cards.filter(function (c) { return c.dataset.variant; });
    if (summary) {
      var total = cards.reduce(function (n, c) { return n + (c.dataset.available === "true" ? Number(c.dataset.price) || 0 : 0); }, 0);
      summary.textContent = cards.length + (cards.length === 1 ? " product" : " products") + (total ? " · " + money(total) : "");
      summary.hidden = cards.length === 0;
    }
    if (actions) {
      actions.hidden = direct.length < 2;
      var btn = actions.querySelector("[data-ns-wl-addall]");
      if (btn) btn.textContent = "Add all " + direct.length + " to cart";
    }
    loadRecs(cards);
  }

  var recsFor = null;
  function loadRecs(cards) {
    var box = q("[data-ns-wl-recs]"), grid = q("[data-ns-wl-recs-grid]");
    if (!box || !grid) return;
    var seed = cards[0] && cards[0].dataset.id;
    if (!seed) { box.hidden = true; return; }
    var saved = {};
    items.forEach(function (x) { saved[x.handle] = true; });
    var draw = function (html) {
      grid.textContent = "";
      var n = 0;
      fragment(html || "").querySelectorAll("[data-ns-wl-rec]").forEach(function (el) {
        if (n < 4 && !saved[el.dataset.handle]) { grid.appendChild(el); n++; }
      });
      box.hidden = n === 0;
      decorateCards(grid);
      loadImages(grid);
    };
    if (recsFor && recsFor.seed === seed) { recsFor.html.then(draw); return; }
    recsFor = {
      seed: seed,
      html: fetch("/recommendations/products?product_id=" + encodeURIComponent(seed) + "&limit=8&section_id=ns-wishlist-recs")
        .then(function (r) { return r.ok ? r.text() : ""; })
        .catch(function () { return ""; }),
    };
    recsFor.html.then(draw);
  }

  function addAll(btn) {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-ns-wl-grid] [data-ns-wl-card][data-variant]"));
    if (!cards.length) return;
    var lines = cards.map(function (c) { return { id: Number(c.dataset.variant), quantity: 1 }; });
    emit("wishlist_add_to_cart", { wl_source: "page_all", wl_added: cards.length });
    var B = booster(), C = B && B.cart;
    if (C && typeof C.addToCartJSON === "function") {
      // Booster's own queue: same request, cart drawer + count, "Add To Cart" analytics, and the
      // "Item added to cart / Recommended for you" popup, exactly as a product-page add.
      btn.disabled = true;
      C.addToCartJSON(false, { items: lines }, false);
      say("Added " + cards.length + " products to your cart");
      setTimeout(function () { btn.disabled = false; }, 1500);
      return;
    }
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: lines }),
    }).then(function (r) {
      if (!r.ok) throw new Error("cart " + r.status);
      toast("Added " + cards.length + ' products to your cart. <a href="/cart">View cart</a>');
      say("Added " + cards.length + " products to your cart");
    }).catch(function () {
      toast("Sorry, we couldn't add those to your cart. Please try again.");
    }).then(function () { btn.disabled = false; });
  }

  // ── start ───────────────────────────────────────────────────────────────
  decorateCards(document);
  decoratePdp();
  decorateMobileMenu();
  refresh();
  watch();
  if (pageEl) {
    var addAllBtn = document.querySelector("[data-ns-wl-addall]");
    if (addAllBtn) addAllBtn.addEventListener("click", function () { addAll(addAllBtn); });
    emit("wishlist_view", { wl_source: "page" });
  }

  if (cfg.loggedIn) {
    var guest = readGuest();
    if (guest.length) {
      // Signed in with a list saved on this device as a guest: move it into the account.
      Promise.all(guest.map(function (x) {
        return (x.id ? Promise.resolve(x.id) : resolveId(x.handle).catch(function () { return null; }))
          .then(function (id) { return { product_id: id, handle: x.handle }; });
      }))
        .then(function (list) { return api("POST", { action: "merge", items: list.filter(function (x) { return x.product_id; }) }); })
        .then(function (j) { lsDel(LS_KEY); adoptServer(j); emit("wishlist_merge", { wl_merged: guest.length }); })
        .catch(function () { /* keep the guest list; try again next page */ });
    } else if (!cfg.hasCopy || !ssGet(SYNC_KEY) || pageEl) {
      // The theme's copy can lag a write (or be missing if it failed): ask the server once a session.
      api("GET").then(function (j) { ssSet(SYNC_KEY, "1"); adoptServer(j); }).catch(function () { /* keep the theme's copy */ });
    }
  }
})();
